import axios from 'axios';
import ReduxThunk from 'redux-thunk';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const USER_DEVICE_BASE_URL = `${apiUrl}/api/2.0/user_devices`;

export function registerDevice(device){
  const data = {
    device_id: device
  }

  return axios({
    method: 'POST',
    url: USER_DEVICE_BASE_URL,
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    params: data
  })
  .then(response => {
    console.log('Successfully registered device');
  })
  .catch(error => {
    console.log('Failed registering device %s', device);
  })
}

export function deregisterDevice(device){
  const data = {
    device_id: device
  }

  return axios({
    method: 'DELETE',
    url: USER_DEVICE_BASE_URL,
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    params: data
  })
  .then(response =>{
    console.log('Successfully deregistered device');
  })
  .catch(error =>{
    console.log('Failed deregistering device %s', device);
  })
}
